import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';

import Img from './Img';

import W from '../styled/Wrapper';

const Wrapper = styled(W)`
  position: relative;
  min-height: ${({ minH }) => (minH ? `${minH}px` : '100vh')};
  margin: 0 auto 100px;

  @media only screen and (max-width: 810px) {
    margin-bottom: 20px;
  }
`;

const Imgs = ({ locs, data }) => {
  const [minH, setMinH] = useState(false);
  const [highestZ, setHighestZ] = useState(2);
  const wrapperEl = useRef(null);

  const isMob = useMediaQuery({
    query: '(max-width: 810px)',
  });

  const checkHeights = () => {
    let lowest = 0;

    if (wrapperEl.current) {
      Array.from(wrapperEl.current.children).forEach((el) => {
        const bottom = el.offsetTop + el.offsetHeight;
        if (bottom > lowest) {
          lowest = bottom;
        }
      });
    }

    if (lowest > 0) {
      setMinH(lowest);
    }
  };

  useEffect(() => {
    checkHeights();

    const handleResize = () => checkHeights();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMob]);

  return (
    <Wrapper minH={minH} ref={wrapperEl}>
      {locs && locs.images
        ? locs.images.map((item, i) => {
            return (
              <Img
                key={i}
                i={i}
                image={item.image}
                video={item.videoUrl}
                solo={locs.images.length === 1}
                highestZ={highestZ}
                setHighestZ={setHighestZ}
                loop={item.loop}
                checkHeights={checkHeights}
                loopWithSound={item.loopWithSound}
                poster={item.image}
              />
            );
          })
        : data.images.map((item, i) => {
            return (
              <Img
                key={i}
                i={i}
                image={item.image}
                video={item.videoUrl}
                solo={data.images.length === 1}
                highestZ={highestZ}
                setHighestZ={setHighestZ}
                loop={item.loop}
                checkHeights={checkHeights}
                loopWithSound={item.loopWithSound}
                poster={item.image}
              />
            );
          })}
    </Wrapper>
  );
};

export default Imgs;
